import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';
import { IconType } from 'react-icons';

/**
 * Helper function to create an icon component from react-icons
 * This resolves TypeScript compatibility issues between react-icons and Chakra UI
 */
export function createIconComponent(IconComponent: IconType) {
  const IconWrapper = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
    <Icon as={IconComponent as any} ref={ref} {...props} />
  ));
  IconWrapper.displayName = `IconWrapper(${(IconComponent as any).displayName || (IconComponent as any).name || 'Icon'})`;
  return IconWrapper;
}

/**
 * Helper to render an icon element
 * @param IconComponent - The icon component from react-icons
 * @param props - Icon props
 */
export function iconElement(IconComponent: IconType, props?: IconProps) {
  return <Icon as={IconComponent as any} {...props} />;
}

/**
 * Helper to safely use react-icons with Chakra UI's Icon component
 * This resolves type compatibility issues by casting the icon type
 */
export function asIcon(IconComponent: IconType) {
  return IconComponent as any;
}

/**
 * Helper to render react-icons as JSX elements for use in Chakra UI components
 * This solves the ReactNode vs JSX element compatibility issue
 */
export function renderIcon(IconComponent: IconType, props?: { size?: string | number; color?: string }) {
  return React.createElement(IconComponent as any, props);
}